module.exports = __webpack_public_path__ + "img/fff-black.1d10f436.png";